import { createContext, useContext, useMemo } from "react";
import useImageModal from "../hooks/useImageModal";

const ImageContext = createContext();

export default function ImageModalProvider({ children }) {
  const { modal, openModal, closeModal } = useImageModal();

  const context = useMemo(
    () => ({ openModal, closeModal }),
    [openModal, closeModal]
  );

  return (
    <ImageContext.Provider value={context}>
      {children}
      {modal}
    </ImageContext.Provider>
  );
}

export function useImageContext() {
  return useContext(ImageContext);
}
